<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
  >
    <g clip-path="url(#clip0_622_2452)">
      <path
        d="M3.37648 3.87816C2.54195 4.90872 2.15058 6.22825 2.28919 7.54707L3.93551 23.2108C4.01175 23.9361 4.37319 24.6013 4.94 25.0603C5.50681 25.5193 6.23255 25.7345 6.9579 25.6583L20.3839 24.2471C21.1093 24.1709 21.7744 23.8095 22.2334 23.2427C22.6924 22.6758 22.9077 21.9501 22.8314 21.2248C22.8127 21.047 22.7755 20.8732 22.7238 20.7048C22.9823 20.5443 23.2164 20.3433 23.4116 20.1023C23.8706 19.5355 24.0859 18.8097 24.0096 18.0844L22.4417 3.16656C22.3655 2.44122 22.004 1.77609 21.4372 1.31709C20.8704 0.858102 20.1447 0.642846 19.4193 0.719083L6.73916 2.05182C5.42034 2.19043 4.21101 2.8476 3.37648 3.87816Z"
        fill="white"
      />
      <path
        d="M19.6284 2.70817L6.94821 4.04091C6.15692 4.12407 5.43108 4.51818 4.93036 5.13651C4.42964 5.75485 4.19506 6.54677 4.27823 7.33806L5.92455 23.0018C5.94535 23.1996 6.04387 23.3811 6.19846 23.5062C6.35304 23.6314 6.55102 23.6901 6.74884 23.6693L20.1749 22.2581C20.3727 22.2373 20.5542 22.1388 20.6794 21.9842C20.8045 21.8297 20.8632 21.6317 20.8424 21.4339C20.8216 21.236 20.7231 21.0546 20.5685 20.9294C20.4139 20.8042 20.2159 20.7456 20.0181 20.7664L7.33794 22.0991C7.29636 21.7034 7.41365 21.3075 7.664 20.9983C7.91436 20.6892 8.27729 20.4921 8.67293 20.4505L21.3531 19.1178C21.5509 19.097 21.7324 18.9985 21.8575 18.8439C21.9827 18.6893 22.0414 18.4913 22.0206 18.2935L20.4527 3.37566C20.4319 3.17784 20.3333 2.99638 20.1788 2.8712C20.0242 2.74602 19.8262 2.68738 19.6284 2.70817ZM18.3314 11.8941L15.7555 10.3549C15.6859 10.3133 15.6046 10.2953 15.5239 10.3038C15.4432 10.3123 15.3674 10.3467 15.308 10.4019L13.1102 12.4428L12.3262 4.98392L17.5475 4.43514L18.3314 11.8941Z"
        fill="#2870ED"
      />
    </g>
    <defs>
      <clipPath id="clip0_622_2452">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 2.50879) rotate(-6)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>
